package com.essntl.uikit

actual val currentPlatform: Platform = Platform.Web